import { Component, Input, OnInit } from '@angular/core'
import { refundList } from 'src/app/modules/refund/models/refund.model'
import { Router } from '@angular/router'
import { AppointmentStatus } from 'src/app/modules/booking/models/appointment.enum'

@Component({
	selector: 'app-refunds-table',
	templateUrl: './refunds-table.component.html',
	styleUrls: ['./refunds-table.component.scss'],
})
export class RefundsTableComponent implements OnInit {
	@Input() refunds: refundList[] = []
	@Input() refundsFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		SearchText: '',
		status: 1,
		countryId: null,
	}
	@Input() totalCount = 0
	appointmentStatus = AppointmentStatus

	constructor(private router: Router) {}

	ngOnInit(): void {}

	takeAction(id: number) {
		this.router.navigateByUrl(`/layout/refunds/refund-details/${id}`)
	}
}
